import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import * as React from "react";

export interface ILinearProgressBar {
  message: string;
  statusComplete: () => void;
  timeInterval: number;
  typoSize?: number;
}

const LinearProgressBar = (props: ILinearProgressBar) => {
  const [progress, setProgress] = React.useState(0);
  const [remainingTime, setRemainingTime] = React.useState(0);

  React.useEffect(() => {
    if (progress < 100) {
      let count = 21;
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
          }

          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 100);
        });
        if (count > 0) {
          setRemainingTime(count - 1);
          count--;
        }
      }, props.timeInterval);
      return () => {
        clearInterval(timer);
      };
    }
  }, []);

  React.useEffect(() => {
    if (progress === 100) props.statusComplete();
  }, [progress]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle2" color="white" sx={{ fontWeight: "500" }}>
        {props.message}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: "1rem",
          borderRadius: "1rem",
          "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: props?.typoSize === 1 ? "#D65C5C" : "#56CCF2",
          },
        }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant={props?.typoSize === 1 ? "caption" : "body2"}
        >{`${remainingTime} seconds remaining time `}</Typography>
        <Typography variant={props?.typoSize === 1 ? "caption" : "body2"}>
          {progress.toFixed()}%
        </Typography>
      </div>
    </Box>
  );
};
export default LinearProgressBar;
